import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {DateRange} from '../../../../models/date-range';
import {MeasureReportTimeline} from '../measure-setting/measure-setting.component';
import {NgbDate} from '@ng-bootstrap/ng-bootstrap/datepicker/ngb-date';
import {AchooDatepickerRangeComponent} from '../../../core/achoo-datepicker-range/achoo-datepicker-range.component';
import {NgbCalendar} from '@ng-bootstrap/ng-bootstrap';
import {NgbDateUtils} from '../../../utils/ngb-date.utils';
import {DateUtils} from '../../../utils/date.utils';

@Component({
  selector: 'measure-date-range-selection',
  templateUrl: './measure-date-range-selection.component.html',
  styleUrls: ['./measure-date-range-selection.component.scss']
})
export class MeasureDateRangeSelectionComponent implements OnInit, AfterViewInit {
  @ViewChild('dateRangePicker') dateRangePicker: AchooDatepickerRangeComponent;
  @Output() hideDateRangePopupEvent: EventEmitter<any> = new EventEmitter();
  @Output() changeDateRange: EventEmitter<any> = new EventEmitter();
  @Input() preSelectedPeriod: DateRange;
  private fromDate: NgbDate;
  private toDate: NgbDate;
  private hasChangedDate = false;
  // ES data won't available before 18 Oct, 2018
  public minDate = NgbDate.from({
    year: 2018,
    month: 10,
    day: 18
  });

  constructor(private calendar: NgbCalendar) {
  }

  ngOnInit() {
    if (this.preSelectedPeriod) {
      this.fromDate = NgbDateUtils.convertNgbDate(this.preSelectedPeriod.formattedStartDate);
      this.toDate = NgbDateUtils.convertNgbDate(this.preSelectedPeriod.formattedEndDate);
    } else {
      this.toDate = this.calendar.getToday();
      this.fromDate = this.calendar.getPrev(this.toDate, 'd', MeasureReportTimeline.A_MONTH);
    }
  }

  ngAfterViewInit() {
    if (this.fromDate) {
      setTimeout(() => {
        this.dateRangePicker.navigateTo(this.fromDate);
      }, 100);
    }
  }

  get defaultFromDate() {
    return this.fromDate;
  }

  get defaultToDate() {
    return this.toDate;
  }

  get maxDate() {
    return this.calendar.getToday();
  }

  onSelectDateRange(evt) {
    this.hasChangedDate = !NgbDateUtils.equals(this.fromDate, evt.fromDate)
      || !NgbDateUtils.equals(this.toDate, evt.toDate);
    this.fromDate = evt.fromDate;
    this.toDate = evt.toDate;
  }

  resetDateRangeSelection() {
    this.dateRangePicker.resetDateRange();
    const today = this.calendar.getToday();
    this.onSelectDateRange({
      fromDate: this.calendar.getPrev(today, 'd', MeasureReportTimeline.A_MONTH),
      toDate: today
    });
  }

  applyDateRangeSelection() {
    this.changeDateRange.emit({
      fromDate: this.fromDate,
      toDate: this.toDate
    });
    this.hasChangedDate = false;
  }

  onClickedOutside(evt) {
    if (!evt.target.classList.contains('date-range-selection') && !evt.target.classList.contains('custom-day')) {
      if (this.fromDate && this.toDate && this.hasChangedDate) {
        this.applyDateRangeSelection();
      }
      this.hideDateRangePopupEvent.emit(evt);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/main/measure/measure-date-range-selection/measure-date-range-selection.component.ts